<template>
  <modal @close="$emit('close')">
    <template #body>
      <div class="modal-write">
        <div class="modal-write__form">
          <div class="modal-write__title">Подобрать недвижимость</div>
          <div class="modal-write__info">
            Расскажите, что ищете — менеджер свяжется и поможет с выбором
          </div>

          <div v-if="success" class="fre-success">
            <div class="fre-success__icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
                <circle cx="24" cy="24" r="23" stroke="#1B1918" stroke-width="1.5"/>
                <polyline points="14,24 21,31 34,17" fill="none" stroke="#1B1918" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3 class="fre-success__title">Запрос отправлен</h3>
            <p class="fre-success__text">Наш менеджер свяжется с вами в ближайшее время.</p>
          </div>

          <form v-else @submit.prevent="send" novalidate>
            <div class="modal-write__inputs-row">
              <Input placeholder="Как вас зовут" type="text" class="input input-full" v-model="name" />
              <Input placeholder="Ваш телефон" type="tel" class="input input-full" v-model="phone" />
            </div>
            <div class="modal-write__input-box">
              <Input placeholder="Ваш email (необязательно)" type="email" class="input input-full" v-model="email" />
            </div>
            <div class="modal-write__input-box">
              <select class="fre-select" v-model="purpose">
                <option value="">Что ищете</option>
                <option value="Для жизни">Для жизни</option>
                <option value="Для инвестиций">Для инвестиций</option>
                <option value="Для аренды">Для аренды</option>
                <option value="Ещё не определился">Ещё не определился</option>
              </select>
            </div>
            <div class="modal-write__input-box">
              <Textarea
                placeholder="Бюджет, локация, пожелания — всё это поможет подобрать вариант"
                class="input input-full"
                v-model="comment"
              />
            </div>

            <button type="submit" class="full-dark-btn fp-submit" :disabled="!agreed">
              Отправить запрос
            </button>

            <Checkbox
              label="Я соглашаюсь с <a href='/privacy'>политикой конфиденциальности</a>"
              :isCheck="agreed"
              name="agreement_politic"
              @change="agreed = $event"
            />

            <p v-if="error" class="fre-error">{{ error }}</p>
            <LoginHint />
          </form>
        </div>
      </div>
    </template>
  </modal>
</template>

<script setup>
import LoginHint from "~/components/UI/LoginHint.vue";
import modal from '~/components/UI/Modal.vue'
import Input from '~/components/UI/inputs/Input.vue'
import Textarea from '~/components/UI/inputs/Textarea.vue'
import Checkbox from '~/components/UI/btn/Checkbox.vue'
import api from '~/api/api.js'

defineEmits(['close'])

const name    = ref('')
const phone   = ref('')
const email   = ref('')
const purpose = ref('')
const comment = ref('')
const agreed  = ref(false)
const success = ref(false)
const error   = ref('')

watch(phone, (val) => {
  let digits = val.replace(/\D/g, '')
  if (digits.startsWith('7') || digits.startsWith('8')) digits = digits.slice(1)
  digits = digits.slice(0, 10)
  let masked = '+7'
  if (digits.length > 0) masked += ' ' + digits.slice(0, 3)
  if (digits.length > 3) masked += ' ' + digits.slice(3, 6)
  if (digits.length > 6) masked += '-' + digits.slice(6, 8)
  if (digits.length > 8) masked += '-' + digits.slice(8, 10)
  if (phone.value !== masked) phone.value = masked
})

async function send() {
  error.value = ''
  if (!name.value.trim() || !phone.value.trim()) {
    error.value = 'Заполните имя и телефон.'
    return
  }
  if (!agreed.value) {
    error.value = 'Подтвердите согласие.'
    return
  }

  const fd = new FormData()
  fd.append('name', name.value)
  fd.append('phone', phone.value)
  if (email.value) fd.append('email', email.value)
  const fullComment = [purpose.value ? `Цель: ${purpose.value}` : '', comment.value].filter(Boolean).join('\n')
  if (fullComment) fd.append('message', fullComment)

  try {
    await api('/real-estate/inquiry', fd, 'POST')
    success.value = true
    name.value    = ''
    phone.value   = ''
    email.value   = ''
    purpose.value = ''
    comment.value = ''
  } catch {
    error.value = 'Произошла ошибка. Попробуйте ещё раз.'
  }
}
</script>

<style scoped lang="scss">
.fre-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 4rem 2rem 2rem;

  &__icon {
    margin-bottom: 2.4rem;
    svg { display: block; }
  }

  &__title {
    font-size: 2.4rem;
    font-weight: 500;
    color: #1B1918;
    margin-bottom: 1rem;
    line-height: 1.3;
  }

  &__text {
    font-size: 1.6rem;
    color: #888;
    margin-bottom: 2rem;
  }
}

.fre-select {
  width: 100%;
  height: 5rem;
  padding: 0 1.6rem;
  border: 1px solid #e0e0e0;
  border-radius: 2px;
  background: #fff;
  font-size: 1.5rem;
  color: #1B1918;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23999' stroke-width='1.5'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 1.4rem center;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #1B1918;
  }
}

.fre-error {
  margin-top: 1.2rem;
  font-size: 1.4rem;
  color: #c62828;
}
</style>
